<template>
  <fb-form-body>
    <el-form ref="form" :model="formData" label-width="auto">
      <el-form-item :label="$t('lang.专题名称') + '：'" required>
        <nation-input v-model="langName" />
      </el-form-item>

      <el-form-item :label="$t('lang.专题描述') + '：'" required>
        <nation-input v-model="langDescription" />
      </el-form-item>

      <el-form-item :label="$t('lang.主语言') + '：'" required>
        <el-radio-group v-model="formData.lang" style="min-width: 800px">
          <el-row :gutter="24">
            <el-col :span="6" v-for="lang in langList" :key="lang.value + '_key'">
              <el-radio :label="lang.value">{{ lang.name }}（{{ lang.value }}）</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>

      </el-form-item>

      <el-form-item :label="$t('lang.封面') + '：'" required>
        <pic-upload
            :limit="1"
            :action="api.upload"
            :download-url="api.downloadImg"
            :data="{category: 'RECIPE'}"
            v-model="formData.cover" />

      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset">{{ $t('lang.重置') }}</el-button>
      </el-form-item>

    </el-form>
  </fb-form-body>
</template>

<script>
import {handleFilterLang} from "../../utlis/utlis";
import {loadSysSettLang} from "../../js/common";
import NationInput from "../../components/nation/NationInput";
import PicUpload from "../../components/pic-upload/PicUpload";

export default {
  name: "GroupRecipeAdd",
  components: {PicUpload, NationInput},
  data() {
    return {
      api: {
        add: this.$api.specRecipe.add,
        upload: this.$api.file.upload,
        downloadImg: this.$api.file.downloadImg,
      },
      formData: {
        lang: '',
        cover: "",
      },
      langs: [],
      langName: {},
      langDescription: {},

      langList: []
    }
  },
  methods: {
    handleSubmit() {
      let params = {
        ...this.formData,
        langs: this.handleFormatLangData(),
        brandOwnerCode: this.$store.state.userInfo.brandOwnerCode,
      }
      this.$http.post(this.api.add, params).then(res => {
        if(res.data.status != 200) {
          this.$message.error(res.data.desc);
          return;
        }
        this.$message.success(res.data.desc);
        this.$router.back();
      })
    },

    handleFormatLangData() {
      let langs = this.langs.map(item => {
        if(Object.keys(this.langName)) {
          item.name = this.langName[item.lang]
        }

        if(Object.keys(this.langDescription)) {
          item.description = this.langDescription[item.lang]
        }
        return item;
      })
      return langs;
    },

    // 重置
    handleReset() {
      for (const key in this.formData) {
        this.formData[key] = '';
      }
      this.langs = this.langs.map(item => {
        return {
          name: "",
          description: "",
          lang: item.lang,
        }
      });
      this.langDescription = {};
      this.langName = {};

      this.$refs.upload.clearFiles();
    },

    // 上传图片
    handleRemoveFile() {
      this.formData.cover = '';
    },

    handleUploadFile(file) {
      const vm = this;
      if (file.status == 'success') {
        let {response: res} = file;
        if (res.status != 200) {
          vm.$message.error(res.desc);
          return;
        }
        vm.formData.cover = res.data.fileCode;
      }
    },

    handleFormatLang() {
      let list = handleFilterLang(this);
      if(list && list.length) {
        this.langs = list.map(item => {
          return {
            name: "",
            description: "",
            lang: item.value,
          }
        })
      }
      this.langList = list;
    }
  },
  async created() {
    await loadSysSettLang(this);
    this.handleFormatLang();
  }
}
</script>

<style scoped>

.el-form {
  width: 500px;
}

.lang-box {
  display: flex;
  margin-top: 14px;
}


/deep/ .el-radio {
  line-height: 40px;
}

</style>
